import { render, staticRenderFns } from "./ModalNotificationLogs.vue?vue&type=template&id=1b04a3c9&lang=pug&"
import script from "./ModalNotificationLogs.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports